'use strict';

angular.module('ClinicApp').directive('doctorCertificates', function($q, $timeout, OCDomUtil, DoctorService) {
  return {
    scope: {
      doctor: '=doctorCertificates',
    },
    templateUrl: '/views/directives/_doctor-certificates.html',
    link: function($scope, el) {
      $scope.doctor.metadata = $scope.doctor.metadata || {};
      $scope.doctor.metadata.certificates = $scope.doctor.metadata.certificates || [];
      $scope.certificate = {};

      $scope.$watch('certificate.date', function(date) {
        if (date) {
          // Is required to hide date picker because it's closed on blur.
          el.find(".btn[type='submit']").focus();
        }
      });

      $scope.toggleEditMode = function() {
        $scope.editMode = !$scope.editMode;
        if ($scope.editMode && OCDomUtil.isMobileScreen()) {
          $timeout(function() {
            OCDomUtil.scrollTo('.doctor-certificates .ibox-content-footer');
          });
        }
      };

      $scope.disableEditMode = function(form) {
        $scope.certificate = {};
        form.$setPristine();
        form.$setValidity(null, true);
        form._submitted = false;
        $scope.editMode = false;
      };

      $scope.addCertificate = function(form) {
        form._submitted = true;
        if (form.$invalid) {
          return $q.reject();
        }

        const certificates = [...$scope.doctor.metadata.certificates];
        certificates.push({
          name: $scope.certificate.name,
          date: moment($scope.certificate.date).format('YYYY-MM-DD'),
          registrationNumber: $scope.certificate.registrationNumber,
        });

        return updateCertificates(certificates).then(() => {
          $scope.disableEditMode(form);
        });
      };

      $scope.removeCertificate = function(index) {
        const certificates = [...$scope.doctor.metadata.certificates];
        certificates.splice(index, 1);
        return updateCertificates(certificates);
      };

      function updateCertificates(certificates) {
        return DoctorService.updateDoctor($scope.doctor, {
          metadata: {
            certificates,
          },
        }).then(function() {
          $scope.doctor.metadata.certificates = certificates;
        });
      }
    },
  };
});
